import React, { Component } from "react";
import surveyService from "../../../services/surveysService";
import SurveySelect from "./SurveySelect";
import connect from "react-redux/es/connect/connect";
import { ROLE_MPS_ADMIN } from "../../../security/roles";
import SurveySelectDropDown from "./SurveySelectDropDown";

class SurveySelector extends Component {
  constructor(props) {
    super(props);
    this.state = { surveys: [] };
  }

  componentDidMount() {
    let { userRole, surveys, patientTypeId } = this.props;
    if (userRole !== ROLE_MPS_ADMIN) {
      surveyService
        .load(0, true, true, patientTypeId)
        .then(surveys => {
          this.setState({ surveys: surveys.data });
        });
    } else {
      this.setState({ surveys });
    }
  }

  render() {
    let { surveys } = this.state;
    if (this.props.dropdown) {
      return <SurveySelectDropDown {...this.props} surveys={surveys} />;
    }
    return <SurveySelect {...this.props} surveys={surveys} />;
  }
}

export default connect(state => {
  return {
    userRole: state.user.role,
    packageId: state.mpsPackage.packageId,
    surveys: state.mpsPackage.selectedPackage
      ? state.mpsPackage.selectedPackage.surveys
      : []
  };
})(SurveySelector);
